import { defineComponent, inject, ref, shallowRef, computed, watch, onMounted, onBeforeUnmount, triggerRef, resolveComponent, openBlock, createBlock, normalizeProps, guardReactiveProps, withCtx, createElementBlock, createVNode, mergeProps, createCommentVNode, Fragment, renderList } from "vue";
import { c as instance, m as makeConversationName, g as getDisplayNameOfParticipant } from "../malarkeyTwilioAdapter-1c296255.mjs";
import MalarkeyConversationListItem from "./constituants/MalarkeyConversationListItem.es.js";
import { V as VList } from "../_VList-61c79735.mjs";
import { u as useDefaults, _ as _export_sfc } from "../_plugin-vue_export-helper-3194dc60.mjs";
import { b as boundUseI18n } from "../_i18n-e414d464.mjs";
import "../index-64135f7d.mjs";
import "../i18n-35335a5c.mjs";
import "../event-socket/malarkeyEventSocketAdapter.es.js";
import { d as debug } from "../_debug-8b5c3032.mjs";
import "../otpauth.esm-675c01d0.mjs";
import "../sudo-bad5b55e.mjs";
import "../index-13be80af.mjs";
import "../_commonjsHelpers-ca272635.mjs";
import "joi";
import "../helpers-674591c1.mjs";
import "../MalarkeyConversationListItem.vue_vue_type_script_lang-3da40755.mjs";
import "../_VListItem-508e4b13.mjs";
import "../_density-8094aebe.mjs";
import "../MalarkeyContactAvatar-1b079ba3.mjs";
import "../_proxiedModel-031e293c.mjs";
import "../theme-96176369.mjs";
import "../getCurrentInstance-eec76705.mjs";
import "../index-38c53cf2.mjs";
import "../index-703c58ee.mjs";
import "../index-fd2245c5.mjs";
import "../index-dbde2d54.mjs";
const _sfc_main = defineComponent({
  name: "MalarkeyConversationList",
  components: {
    MalarkeyConversationListItem
  },
  props: {
    ...VList.props,
    /**
     * Defines the currently selected conversation
     */
    modelValue: {
      type: String,
      default: void 0
    },
    /**
     * Defines the function used to sort the displayed results.
     */
    sortFn: {
      type: Function,
      default: void 0
    },
    /**
     * Defines the maximum number of items to display. A value of -1 will display all items.
     */
    limit: {
      type: Number,
      default: -1
    }
  },
  emits: [
    ...Object.keys({ ...VList.emits }),
    /**
     * Emitted when the selected conversation changes
     */
    "update:modelValue",
    /**
     * Emitted when the selected conversation changes
     */
    "sid",
    /**
     * Emitted when the selected conversation changes
     */
    "update",
    /**
     * Emitted when the selected conversation changes
     */
    "input"
  ],
  setup(props, { emit }) {
    const { t } = boundUseI18n();
    const bus = inject("bus");
    const cron = inject("cron");
    const defaultsFromVList = useDefaults(props, "VList");
    const defaultsFromMalarkeyConversationList = useDefaults(
      defaultsFromVList,
      "MalarkeyConversationList"
    );
    const search = ref("");
    const conversations = shallowRef([]);
    const populateConversations = () => {
      const ret = [];
      if (instance.value && Array.isArray(instance.value.conversations.value)) {
        const toAdd = [...instance.value.conversations.value].sort((a, b) => {
          if ("function" === typeof props.sortFn) {
            return props.sortFn(a, b);
          } else {
            return 0;
          }
        }).filter((c) => {
          if ("undefined" === typeof c) {
            return;
          }
          if ("string" !== typeof search.value || search.value.trim().length === 0) {
            return true;
          }
          const conversationName = makeConversationName(c);
          if (conversationName && conversationName.toLowerCase().includes(search.value.toLowerCase())) {
            return true;
          }
          const participantNames = [...c._participants.values()].map(
            (p) => getDisplayNameOfParticipant(p)
          );
          if (participantNames.some(
            (n) => "string" === typeof n && n.toLowerCase().includes(search.value.toLowerCase())
          )) {
            return true;
          }
          return false;
        });
        if (props.limit > -1) {
          ret.push(...toAdd.slice(0, props.limit));
        } else {
          ret.push(...toAdd);
        }
      }
      conversations.value = ret;
      triggerRef(conversations);
    };
    const bindings = computed(() => ({
      ...defaultsFromMalarkeyConversationList,
      sortFn: void 0,
      limit: void 0
    }));
    const modelValue = ref(props.modelValue);
    const onSid = (sid) => {
      modelValue.value = sid;
    };
    const onClick = (e, c) => {
      e.preventDefault();
      onSid(c.sid);
    };
    watch(
      () => props.modelValue,
      (value) => {
        modelValue.value = value;
      },
      { immediate: true }
    );
    watch(
      () => modelValue.value,
      (value) => {
        emit("update:modelValue", value);
        emit("sid", value);
        emit("update", value);
        emit("input", value);
      }
    );
    const vTextInputDefaults = useDefaults({}, "VTextField");
    const malarkeyConversationListInputFieldBindings = useDefaults(
      {
        ...vTextInputDefaults,
        noResize: true,
        rowHeight: 16,
        rows: 1,
        density: "compact",
        clearable: true,
        prependInnerIcon: "mdi-magnify",
        placeholder: t("general.search"),
        hideDetails: true
      },
      "MalarkeyConversationListInputField"
    );
    const onConversationFocus = (conversationSid) => {
      debug("Got request to focus conversation", conversationSid);
      onSid(conversationSid);
    };
    onMounted(() => {
      populateConversations();
      if (cron) {
        cron.$on("* * * * *", populateConversations);
      }
      if (bus) {
        bus.on("conversation:focus", onConversationFocus, { local: true });
        bus.on("twilio:client:conversationUpdated", populateConversations, {
          local: true
        });
        bus.on("twilio:client:conversationAdded", populateConversations, {
          local: true
        });
        bus.on("twilio:client:conversationJoined", populateConversations, {
          local: true
        });
        bus.on("twilio:client:conversationLeft", populateConversations, {
          local: true
        });
        bus.on("twilio:client:messageAdded", populateConversations, {
          local: true
        });
        bus.on("twilio:client:messageAdded", populateConversations, {
          local: true
        });
        bus.on("twilio:client:messageRemoved", populateConversations, {
          local: true
        });
        bus.on("twilio:client:messageUpdated", populateConversations, {
          local: true
        });
        bus.on("twilio:client:participantJoined", populateConversations, {
          local: true
        });
        bus.on("twilio:client:participantLeft", populateConversations, {
          local: true
        });
        bus.on("twilio:client:participantUpdated", populateConversations, {
          local: true
        });
        bus.on("conversation:read:index:advanced", populateConversations, {
          local: true
        });
      }
    });
    onBeforeUnmount(() => {
      if (cron) {
        cron.$off("* * * * *", populateConversations);
      }
      if (bus) {
        bus.off("conversation:focus", onConversationFocus, { local: true });
        bus.off("twilio:client:conversationUpdated", populateConversations, {
          local: true
        });
        bus.off("twilio:client:conversationAdded", populateConversations, {
          local: true
        });
        bus.off("twilio:client:conversationJoined", populateConversations, {
          local: true
        });
        bus.off("twilio:client:conversationLeft", populateConversations, {
          local: true
        });
        bus.off("twilio:client:messageAdded", populateConversations, {
          local: true
        });
        bus.off("twilio:client:messageAdded", populateConversations, {
          local: true
        });
        bus.off("twilio:client:messageRemoved", populateConversations, {
          local: true
        });
        bus.off("twilio:client:messageUpdated", populateConversations, {
          local: true
        });
        bus.off("twilio:client:participantJoined", populateConversations, {
          local: true
        });
        bus.off("twilio:client:participantLeft", populateConversations, {
          local: true
        });
        bus.off("twilio:client:participantUpdated", populateConversations, {
          local: true
        });
        bus.off("conversation:read:index:advanced", populateConversations, {
          local: true
        });
      }
    });
    return {
      conversations,
      bindings,
      onClick,
      onSid,
      modelValue,
      search,
      malarkeyConversationListInputFieldBindings
    };
  }
});
const _hoisted_1 = {
  key: 0,
  class: "m-conversation-list-search-wrapper pa-2"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_MalarkeyConversationListItem = resolveComponent("MalarkeyConversationListItem");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_list = resolveComponent("v-list");
  return openBlock(), createBlock(_component_v_list, normalizeProps(guardReactiveProps(_ctx.bindings)), {
    default: withCtx(() => [
      _ctx.conversations.length > 0 || "string" === typeof _ctx.search && _ctx.search.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(_component_v_text_field, mergeProps(_ctx.malarkeyConversationListInputFieldBindings, {
          modelValue: _ctx.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.search = $event)
        }), null, 16, ["modelValue"])
      ])) : createCommentVNode("", true),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.conversations, (c, i) => {
        var _a;
        return openBlock(), createElementBlock(Fragment, {
          key: `${c.checksum}-${i}-${(_a = c.dateUpdated) == null ? void 0 : _a.valueOf()}`
        }, [
          createVNode(_component_MalarkeyConversationListItem, {
            conversation: c,
            disabled: _ctx.disabled,
            active: _ctx.modelValue === c.sid,
            onClick: ($e) => _ctx.onClick($e, c),
            onSid: _ctx.onSid
          }, null, 8, ["conversation", "disabled", "active", "onClick", "onSid"]),
          i < _ctx.conversations.length - 1 ? (openBlock(), createBlock(_component_v_divider, { key: 0 })) : createCommentVNode("", true)
        ], 64);
      }), 128))
    ]),
    _: 1
  }, 16);
}
const MalarkeyConversationList = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MalarkeyConversationList.vue"]]);
export {
  MalarkeyConversationList as default
};
//# sourceMappingURL=MalarkeyConversationList.es.js.map
